<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
            <el-form-item label="客户姓名" prop="cusName">
                <el-input type="text" v-model="dataForm.cusName" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="cusPhone">
                <el-input type="text" v-model="dataForm.cusPhone" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="类别" prop="type">
                <el-radio-group v-model="dataForm.type">
                    <el-radio :label="1">客户</el-radio>
                    <el-radio :label="2">加盟</el-radio>
                    <el-radio :label="3">合作</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="dataForm.type === 1 ? '小区' : '地区'" prop="cusArea">
                <el-input type="text" v-model="dataForm.cusArea" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务员" prop="userId">
                <el-select v-model="dataForm.userId" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in userList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户情况" prop="state">
                <el-radio-group v-model="dataForm.state" size="small">
                    <el-radio :label="1" border>意向</el-radio>
                    <el-radio :label="2" border>订单</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="意向" prop="intention" v-if="dataForm.state===1">
                <el-radio-group v-model="dataForm.intention">
                    <el-radio :label="1">A</el-radio>
                    <el-radio :label="2">C</el-radio>
                    <el-radio :label="3">无效</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="订单" prop="orderPrice" v-if="dataForm.state===2">
                <el-radio-group v-model="dataForm.order">
                    <el-radio :label="1">意向金</el-radio>
                    <el-radio :label="2">定金20000</el-radio>
                    <el-radio :label="3">货款80%</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="渠道" prop="channel">
                <el-select v-model="dataForm.channel" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in channelList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期时间" prop="tempDate">
                <el-date-picker
                        v-model="dataForm.tempDate"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="right"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="需求备注" prop="cusRemark">
                <el-input type="textarea" :rows="5" v-model="dataForm.cusRemark" style="width: 80%;"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {InviteNet} from "../../api/inviteNet";
    import {UdUser} from "../../api/udUser";
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-net-add-or-update",
        data() {
            let validateMobile = (rule, value, callback) => {
                let reg = /^\d{7,11}$/;
                if (!reg.test(value)) {
                    callback(new Error('请输入7-11位的数字！'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                userList: [],
                channelList: [
                    {value: 1, label: '官网'},
                    {value: 2, label: '小程序'},
                    {value: 3, label: '美团'},
                    {value: 4, label: '新媒体'}
                ],
                dataForm: {
                    id: 0,
                    cusName: '',
                    type: 1,
                    userId: '',
                    cusPhone: '',
                    cusArea: '',
                    cusRemark: '',
                    state: 1,
                    intention: 1,
                    order: 1,
                    channel: '',
                    tempDate: DateFormat.dateFormatTime(new Date())
                },
                dataRule: {
                    cusName: [
                        {required: true, message: '客户姓名不能为空', trigger: 'blur'}
                    ],
                    userId: [
                        {required: true, message: '请选择业务员！', trigger: 'blur'}
                    ],
                    cusPhone: [
                        {required: true, message: '手机号码不能为空', trigger: 'blur'},
                        {validator: validateMobile, trigger: 'blur'}
                    ],
                    cusArea: [
                        {required: true, message: '小区不能为空', trigger: 'blur'}
                    ]
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },

        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields()
                    });
                }
            }
        },

        methods: {
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 5) { // 获取网络部人员
                                this.userList.push(item);
                            }
                        });
                    }
                })
            },
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                this.getUserList();
                if (this.dataForm.id) {
                    InviteNet.getIvNetInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.cusName = res.netInfo.cusName;
                            this.dataForm.userId = res.netInfo.userId;
                            this.dataForm.cusPhone = res.netInfo.cusPhone;
                            this.dataForm.cusArea = res.netInfo.cusArea;
                            this.dataForm.type = res.netInfo.type;
                            this.dataForm.channel = res.netInfo.channel;
                            this.dataForm.cusRemark = res.netInfo.cusRemark;
                            this.dataForm.state = res.netInfo.state;
                            this.dataForm.intention = res.netInfo.intention;
                            this.dataForm.order = res.netInfo.order;
                            this.dataForm.tempDate = res.netInfo.dateTime ? res.netInfo.dateTime : DateFormat.dateFormatTime(new Date());
                        }
                    })
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'cusName': this.dataForm.cusName,
                    'userId': this.dataForm.userId,
                    'cusArea': this.dataForm.cusArea,
                    'cusPhone': this.dataForm.cusPhone,
                    'cusRemark': this.dataForm.cusRemark,
                    'type': this.dataForm.type,
                    'channel': this.dataForm.channel,
                    'state': this.dataForm.state,
                    'intention': this.dataForm.state === 1 ? this.dataForm.intention : 4,
                    'order': this.dataForm.state === 2 ? this.dataForm.order : 4,
                    'tempDate': this.dataForm.tempDate
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        InviteNet.addOrUpdateIvNet(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            }
        }

    }
</script>

<style scoped>

</style>
